import { strongPassword } from '@/common/validator/validatorHelpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { accountService } from '@/services/account';
import useVuelidate from '@vuelidate/core';
import { email, helpers, required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useAccountAdd() {
    const model = reactive({
        firstname: '',
        lastname: '',
        email: '',
        password: '',
        repassword: ''
    });

    const validations = {
        firstname: { required },
        lastname: { required },
        email: { required, email },
        password: { strongPassword },
        repassword: {
            required,
            validValue: helpers.withMessage('Passwords do not match', (value: any) => value === model.password)
        }
    };

    const v$ = useVuelidate(validations, model);
    const { excuteAndNotify } = useCrudActions();

    const actions = {
        create: excuteAndNotify({
            validator: v$,
            request: () => accountService.create(model.firstname, model.lastname, model.email, model.password),
            onSuccess: () => {
                // refresh model
                v$.value.$reset();
                model.firstname = '';
                model.lastname = '';
                model.email = '';
                model.password = '';
                model.repassword = '';
            }
        })
    };

    return { model, v$, fetch, actions };
}
